import React, { useMemo } from 'react';

import If from '@components/shared/conditional/If/If';
import styles from './Variations.module.scss';

interface IVariationsProps {
  count: number;
  productGroupUrl?: string;
  className?: string;
  hideVariationsQuantity?: boolean;
}

const Variations = ({
  count,
  productGroupUrl = '',
  className = '',
  hideVariationsQuantity = false
}: IVariationsProps) => {
  if (!count) {
    return null;
  }

  const options = useMemo(() => {
    return hideVariationsQuantity ? '+ options' : `+ ${count - 1} option${count > 2 ? 's' : ''}`;
  }, [count]);

  return (
    <If condition={!!productGroupUrl}>
      <span className={`${styles.Variations} ${className}`}>
        {options}
      </span>
    </If>
  );
};

export default Variations;
